module.exports = __webpack_public_path__ + "media/images/img-travel-3-b7484f15.jpg";